import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import BackrrLoadingAnimation from 'ui-components/route-components/BackrrLoadingAnimation';
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper';
import BreadcrumbHeader from 'layout/BreadcrumbsHeader';

/**
 * OwnerOnlyRoute wrapper that restricts routes to owner/admin only
 * Used for billing, subscription, and sensitive features
 * @param {React.Component} Component - The component to render if user is owner
 * @returns {React.Component} - Either the component, redirect, or loading state
 */
const OwnerOnlyRoute = ({ Component }) => {
  const userAccess = useSelector((state) => state?.permissions);

  if (!userAccess?.isOwner) {
    return <Navigate to="/profile" replace />;
  }

  return <Component />;
};

export default OwnerOnlyRoute;
